import { render } from "./Reanimation.vue?vue&type=template&id=945c55d2&scoped=true"
import script from "./Reanimation.vue?vue&type=script&lang=js"
export * from "./Reanimation.vue?vue&type=script&lang=js"

import "./Reanimation.vue?vue&type=style&index=0&id=945c55d2&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945c55d2"]])

export default __exports__